export default __webpack_public_path__ + "static/media/Padron_1964AOpen.ff666c8c.jpg";